@if (hasShadow$ | async) {
  <div class="shadow"></div>
}
@if (
  {
    authorized: isAuthenticated$ | async,
    isPresentation: isPresentationMode$ | async,
  };
  as data
) {
  <!-- has-dialog: reading the open-dialog count here repaints the route tree on every dialog open/close (WAP-1718) -->
  <div
    class="wrapper"
    [class.bare-layout]="bareLayout"
    [class.has-dialog]="dialogs.openCount() > 0"
  >
    <!-- Absolutely positioned flex child: its static position is the wrapper's top edge, above the header -->
    @if (storeService.isLoading$ | async) {
      <app-progress-bar class="app-progress"></app-progress-bar>
    }
    <sui-shell
      [drawerOpen]="drawerOpen()"
      (drawerOpenChange)="drawerOpen.set($event)"
    >
      <!-- ngProjectAs: a slot element inside a control-flow block is not matched by the slot selector on its own -->
      <ng-container ngProjectAs="sui-shell-topbar">
        @if (data.authorized && !hideHeader) {
          <sui-shell-topbar>
            <app-header (menuToggle)="drawerOpen.set(!drawerOpen())"></app-header>
          </sui-shell-topbar>
        }
      </ng-container>
      <ng-container ngProjectAs="sui-shell-sidenav">
        @if (data.authorized && !hideHeader) {
          <sui-shell-sidenav>
            <app-main-menu></app-main-menu>
          </sui-shell-sidenav>
        }
      </ng-container>
      <div class="content" [ngClass]="{ logged: isAuthenticated$ | async }">
        <app-banner-container></app-banner-container>
        <div class="pane-container">
          @if (pageLoadError.message()) {
            <app-page-load-error></app-page-load-error>
          } @else {
            <router-outlet></router-outlet>
          }
        </div>
      </div>
    </sui-shell>

    @if (userAccessLevel >= UserAccessLevel.GLOBAL_ADMIN) {
      <app-release-notes> </app-release-notes>
    }
  </div>
}
